import { ConfirmMessage } from 'models/confirmMessage';
import { getFormattedPrice } from 'utils/currency';

export const mapPriceCurrency = (price: string, locale: string) => {
  const aux = price.split(' ');
  const num = Number(aux[aux.length > 1 ? 1: 0].replaceAll(',', '.'));
  if (isNaN(num)) {
    return price;
  } else {
    const { formatted } = getFormattedPrice({ value: num, currency: aux[0], l: locale });
    return formatted;
  }
};

export const mapPrices = (errors: string[], locale: string, splitChar?: string) => {
  const message = errors.find((e) => e.indexOf('PriceChanged') > -1);
  if (message === undefined) return {};

  let prices = {};
  const splitC = splitChar ?? '|';
  const aux = message.split(splitC).map((m) => m.split(':'));
  aux.forEach((val) => {
    let res = val.find((v) => v.includes('PreviousPrice'));
    if (res) prices = { ...prices, previousPrice: mapPriceCurrency(val[1].trim(), locale) };
    res = val.find((v) => v.includes('UpdatedPrice'));
    if (res) prices = { ...prices, updatedPrice: mapPriceCurrency(val[1].trim(), locale) };
  });
  return prices;
};

interface ErrorMessage {
  message: ConfirmMessage;
  button?: boolean;
  props?: any;
}

export const getErrorMessage = (errors: string[], locale: string, isApproval: boolean): ErrorMessage => {
  if (errors.find((e) => e.indexOf('PriceChanged') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.priceChanged.title',
        text: 'travelApproval.priceChanged.text',
      },
      props: mapPrices(errors, locale),
      button: true,
    };
  }
  if (errors.find((e) => e.indexOf('Expired') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.expired.title',
        text: 'travelApproval.expired.text',
      },
      button: true,
    };
  }
  if (errors.find((e) => e.indexOf('AlreadyPaid') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.alreadyPaid.title',
        text: 'travelApproval.alreadyPaid.text',
      },
      button: true,
    };
  }
  if (errors.find((e) => e.indexOf('AlreadyApproved') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.alreadyApproved.title',
        text: 'travelApproval.alreadyApproved.text',
      },
      button: true,
    };
  }
  if (errors.find((e) => e.indexOf('AlreadyReproved') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.alreadyReproved.title',
        text: 'travelApproval.alreadyReproved.text',
      },
      button: true,
    };
  }
  if (errors.find((e) => e.indexOf('CannotRepprove') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.cannotRepprove.title',
        text: 'travelApproval.cannotRepprove.text',
      },
      button: true,
    };
  }
  if (
    errors.find(
      (e) =>
        e.indexOf('UserNotFoundOnFirstLevelApproval') > -1 ||
        e.indexOf('primer nivel') > -1 ||
        e.indexOf('primeiro nível') > -1 ||
        e.indexOf('first level') > -1,
    ) !== undefined
  ) {
    return {
      message: {
        title: 'travelApproval.userNotFoundOnFirstLevelApproval.title',
        text: 'travelApproval.userNotFoundOnFirstLevelApproval.text',
      },
      button: true,
    };
  }

  if (errors.find((e) => e.indexOf('Cancelled') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.cancelled.title',
        text: 'travelApproval.cancelled.text',
      },
      button: true,
    };
  }

  if (errors.find((e) => e.indexOf('CannotCancel') > -1) !== undefined) {
    return {
      message: {
        title: 'travelApproval.cannotCancel.title',
        text: 'travelApproval.cannotCancel.text',
      },
      button: true,
    };
  }

  if (isApproval) {
    return {
      message: {
        title: 'travelApproval.error.title',
        text: 'travelApproval.error.text',
      },
    };
  }

  if (!isApproval) {
    return {
      message: {
        title: 'travelApproval.genericReproval.title',
        text: 'travelApproval.genericReproval.text',
      },
    };
  }
  return {
    message: {
      title: 'travelApproval.error.title',
      text: 'travelApproval.error.text',
    },
  };
};
